import React, { useContext, useEffect, useState } from 'react';

import { Check } from '@mui/icons-material';
import { Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import CustomSnackbar from '../../uiParts/CustomSnackbar';
import SideBar from '../../uiParts/SideBar';
import { gray100, primaryButtonOutlinedColor } from '../../../constants/Colors';
import { sideBarWidth } from '../../../constants/Location';
import { AuthContext } from '../../../contexts/auth';
import { browserBack } from '../../../modules/error';
import CustomHead from '../CustomHead';

const styles = {
  button: {
    fontSize: '16px',
    fontWeight: 500,
    mt: '80px'
  },
  container: {
    m: '0 auto',
    p: `160px 0 0 ${sideBarWidth}`,
    width: `calc(560px + ${sideBarWidth})`,
    '@media screen and (max-width: 960px)': {
      m: '0 auto',
      maxWidth: '560px',
      p: '64px 0 0',
      width: '90%'
    }
  },
  icon: {
    fontSize: '80px',
    width: '100%',
    '@media screen and (max-width: 960px)': {
      fontSize: '64px'
    }
  },
  text: {
    color: gray100,
    mt: '24px',
    textAlign: 'center',
    '@media screen and (max-width: 960px)': {
      mt: '16px'
    }
  },
  title: {
    color: gray100,
    fontSize: '24px',
    fontWeight: 500,
    mt: '16px',
    '@media screen and (max-width: 960px)': {
      textAlign: 'center',
      maxWidth: '243px'
    }
  },
  pageWrapper: {
    '@media screen and (max-width: 960px)': {
      flexDirection: 'column'
    }
  },
  primaryButtonOutlinedColor
};

const AccountBasicComplete: React.FC = () => {
  const navigate = useNavigate();
  const [errorText, setErrorText] = useState('');
  const [finishStatus, setFinishStatus] = useState(false);
  const [open, setOpen] = useState(false);

  const browserBackAlert = (e: { preventDefault: () => void }): void => {
    if (!finishStatus) {
      e.preventDefault();
      setOpen(true);
      setErrorText(browserBack);
      window.history.pushState(null, '', window.location.pathname);
      setFinishStatus(false);
    }
  };

  useEffect(() => {
    history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', browserBackAlert);
    return () => {
      window.removeEventListener('popstate', browserBackAlert);
    };
  }, []);

  // ログインチェック
  const { isLoggedIn } = useContext(AuthContext);
  useEffect((): void => {
    if (!isLoggedIn) {
      navigate('/auth/login');
      return;
    }
  }, []);

  return (
    <>
      <CustomHead title="基本情報変更完了 | CMCOS[コムコス]" />
      <Grid container sx={styles.pageWrapper}>
        <SideBar />
        <Grid
          alignItems="center"
          container
          direction="column"
          item
          sx={styles.container}
        >
          <Check sx={styles.icon} />
          <Typography sx={styles.title}>変更が完了しました</Typography>
          <Button
            fullWidth
            onClick={() => navigate('/account')}
            sx={[styles.button, styles.primaryButtonOutlinedColor]}
            variant="outlined"
          >
            アカウント管理へ
          </Button>
          <CustomSnackbar
            autoHideDuration={6000}
            onClose={() => setOpen(false)}
            open={open}
            text={errorText}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AccountBasicComplete;
